import { useEffect } from 'react';

/**
 * Ensure mouse wheel scrolls the main page when the pointer is over dashboard content.
 * AdminLTE can leave a non-scrollable layer under the cursor while only the scrollbar works.
 */
export function useDashboardPageScroll(active) {
  useEffect(() => {
    if (!active || typeof window === 'undefined') return undefined;

    const onWheel = (e) => {
      if (!document.body.classList.contains('dashboard-app-active')) return;

      let el = e.target;
      while (el && el !== document.body) {
        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        if (
          (overflowY === 'auto' || overflowY === 'scroll') &&
          el.scrollHeight > el.clientHeight + 1
        ) {
          const atTop = el.scrollTop <= 0;
          const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
          if ((e.deltaY < 0 && !atTop) || (e.deltaY > 0 && !atBottom)) {
            return;
          }
        }
        el = el.parentElement;
      }

      window.scrollBy({ top: e.deltaY, left: 0, behavior: 'auto' });
    };

    window.addEventListener('wheel', onWheel, { passive: true });
    return () => window.removeEventListener('wheel', onWheel);
  }, [active]);
}
